import React from 'react';
import * as Switch from '@/components/ui/switch';
import chevronIcon from '@/assets/icons/chevron-primary.svg';
import { useNavigate } from 'react-router-dom';

const AccountCenterToggleItem = ({
  item,
  budget,
  onChange,
  defaultChecked = false,
  value = undefined,
  budgetId,
  acCenter,
  disabled = false,
  showToggle = true
}: any) => {
  // If value is provided, use it; otherwise, use defaultChecked for the initial state
  const isChecked = value !== undefined ? value : defaultChecked;
  const navigate = useNavigate();

  const handleCheckChange = (checked: boolean) => {
    if (disabled) {
      return;
    }

    // Pass the new checked state and a setState function to the parent component
    onChange(checked, (newValue: boolean) => {
      // This setChecked function will be called by the parent component
      // to update the state based on API success or failure
    });
  };

  console.log('budget', budget);

  const handleACItemClick = () => {
    // Additional functionality when clicking the item (if needed)
    if (isChecked) {
      navigate(`/budgets/${budgetId}/accounting-centers/${item.value.toLowerCase()}`, {
        state: { acCenter, budget }
      });
    }
  };

  return (
    <div
      key={item.value}
      className={`cursor-default z-10 flex justify-start gap-3 w-full p-0 py-[0.85rem] overflow-hidden md:py-0 border-b border-white last:border-b-0 md:border md:border-lightPurple-200 md:px-4 md:pr-0 md:last:border md:last:border-lightPurple-200 md:rounded-[8px]`}
    >
      <div className="py-[0.85rem] w-full flex items-center gap-3">
        <img src={item.icon} alt={`dept icon`} />
        <div className="flex flex-1 flex-col gap-[2px] w-[72%]">
          <button
            onClick={handleACItemClick}
            className={`${isChecked ? 'cursor-pointer' : 'cursor-default'} w-fit text-sm font-bold leading-[17px] text-left capitalize`}
          >
            {item.title}
          </button>
        </div>
      </div>
      {showToggle && (
        <div className="flex items-center justify-center mr-[0.4rem]">
          <Switch.Switch
            checked={isChecked}
            onCheckedChange={handleCheckChange}
            disabled={disabled}
            className={`
            data-[state=checked]:bg-primary
            data-[state=unchecked]:bg-[#E9ECEF]
          `}
          />
        </div>
      )}
      <div
        onClick={handleACItemClick}
        className={`flex items-center justify-center w-[22px] ${isChecked ? 'bg-[#DBD6FF] cursor-pointer' : 'bg-[#F3F1FF]'} `}
      >
        <img className={`rotate-90 ${isChecked ? '' : 'opacity-50'} `} src={chevronIcon} alt={`chevron icon`} />
      </div>
    </div>
  );
};

export default AccountCenterToggleItem;
